(function () {
  'use strict';

  /* ============================================================
     Yummii Yummii Header — Vanilla JS IIFE
     CSS handles desktop hover automatically via @media (hover: hover).
     JS handles: mobile drawer, touch/keyboard mega open, ESC close.
     Toggle class: .is-open on .yy-has-mega / .yy-drawer / .yy-scrim
  ============================================================ */

  /* ---- Sticky placeholder ----------------------------------- */
  var stickyHdr = document.querySelector('.yy-header--sticky');
  if (stickyHdr) {
    var ph = document.createElement('div');
    ph.id = 'yy-hdr-placeholder';
    ph.style.cssText = 'display:block;pointer-events:none;';
    stickyHdr.insertAdjacentElement('afterend', ph);

    function syncPlaceholder() {
      ph.style.height = stickyHdr.offsetHeight + 'px';
    }
    syncPlaceholder();
    window.addEventListener('resize', syncPlaceholder, { passive: true });
  }

  var header = document.querySelector('header.yy-header');
  if (!header) return;

  /* ============================================================
     TRANSPARENT → SOLID (homepage only)
     .yy-header--transparent starts see-through over the hero and
     becomes solid (.is-solid) on scroll, or while a mega menu /
     mobile drawer is open — mirrors the reference design's
     `solid = scrolled || !!open`.
  ============================================================ */
  var isTransparentHeader = header.classList.contains('yy-header--transparent');
  function syncSolidHeader() {
    if (!isTransparentHeader) return;
    var anyMegaOpen = false;
    header.querySelectorAll('.yy-has-mega').forEach(function (item) {
      if (item.classList.contains('is-open') || (item.matches && item.matches(':hover'))) {
        anyMegaOpen = true;
      }
    });
    var drawerEl = document.getElementById('yy-drawer');
    var drawerOpen = !!(drawerEl && drawerEl.classList.contains('is-open'));
    var scrolled = window.scrollY > 12;
    header.classList.toggle('is-solid', scrolled || anyMegaOpen || drawerOpen);
  }
  if (isTransparentHeader) {
    window.addEventListener('scroll', syncSolidHeader, { passive: true });
    header.querySelectorAll('.yy-has-mega').forEach(function (item) {
      item.addEventListener('mouseenter', syncSolidHeader);
      item.addEventListener('mouseleave', function () { setTimeout(syncSolidHeader, 150); });
    });
    syncSolidHeader();
  }

  /* ============================================================
     MOBILE DRAWER
  ============================================================ */
  var drawer   = document.getElementById('yy-drawer');
  var scrim    = document.getElementById('yy-scrim');
  var burger   = document.getElementById('yy-burger');
  var closeBtn = document.getElementById('yy-drawer-close');

  function openDrawer() {
    if (!drawer || !scrim) return;
    drawer.classList.add('is-open');
    scrim.classList.add('is-open');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
    syncSolidHeader();
  }

  function closeDrawer() {
    if (!drawer || !scrim) return;
    drawer.classList.remove('is-open');
    scrim.classList.remove('is-open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (burger) burger.focus();
    syncSolidHeader();
  }

  if (burger)   burger.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (scrim)    scrim.addEventListener('click', closeDrawer);

  /* ============================================================
     DESKTOP MEGA MENU
     CSS handles hover automatically. JS adds .is-open for
     keyboard / focus navigation so the menu stays open while
     tabbing through its links.
  ============================================================ */
  var desktopMegaItems = header.querySelectorAll('.yy-navbar .yy-has-mega');

  function closeAllDesktopMegas(except) {
    desktopMegaItems.forEach(function (item) {
      if (item === except) return;
      item.classList.remove('is-open');
      var btn = item.querySelector('.yy-nav__link');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  desktopMegaItems.forEach(function (item) {
    var triggerBtn = item.querySelector('.yy-nav__link');

    /* Click / keyboard Enter toggles .is-open (supplements CSS hover) */
    if (triggerBtn) {
      triggerBtn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        closeAllDesktopMegas(item);
        item.classList.toggle('is-open', !isOpen);
        triggerBtn.setAttribute('aria-expanded', String(!isOpen));
        syncSolidHeader();
      });
    }

    /* Close when focus leaves the entire item */
    item.addEventListener('focusout', function (e) {
      /* Use a rAF so relatedTarget is settled */
      requestAnimationFrame(function () {
        if (!item.contains(document.activeElement)) {
          item.classList.remove('is-open');
          if (triggerBtn) triggerBtn.setAttribute('aria-expanded', 'false');
          syncSolidHeader();
        }
      });
    });
  });

  /* ============================================================
     MOBILE ACCORDION (inside .yy-drawer)
     Toggles .is-open on .yy-has-mega list items.
  ============================================================ */
  var drawerMegaItems = header.querySelectorAll('.yy-drawer .yy-has-mega');

  drawerMegaItems.forEach(function (item) {
    var triggerBtn = item.querySelector('.yy-nav__link');
    if (!triggerBtn) return;

    triggerBtn.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');

      /* Close all other accordion items */
      drawerMegaItems.forEach(function (other) {
        if (other !== item) {
          other.classList.remove('is-open');
          var otherBtn = other.querySelector('.yy-nav__link');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        }
      });

      item.classList.toggle('is-open', !isOpen);
      triggerBtn.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  /* ============================================================
     MOBILE SEARCH TOGGLE
  ============================================================ */
  var searchToggle = document.getElementById('yy-search-toggle');
  var mobileSearch = document.getElementById('yy-mobile-search');

  function openMobileSearch() {
    if (!mobileSearch) return;
    mobileSearch.classList.add('is-open');
    mobileSearch.setAttribute('aria-hidden', 'false');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
    var input = mobileSearch.querySelector('input');
    if (input) setTimeout(function () { input.focus(); }, 50);
  }

  function closeMobileSearch() {
    if (!mobileSearch) return;
    mobileSearch.classList.remove('is-open');
    mobileSearch.setAttribute('aria-hidden', 'true');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      if (mobileSearch && mobileSearch.classList.contains('is-open')) {
        closeMobileSearch();
      } else {
        openMobileSearch();
      }
    });
  }

  /* ============================================================
     SØGE-OVERLAY (fuldskærm, live predictive search)
  ============================================================ */
  var searchov = document.getElementById('yy-searchov');
  if (searchov) {
    var sInput    = document.getElementById('yy-searchov-input');
    var sClear    = document.getElementById('yy-searchov-clear');
    var sDefault  = document.getElementById('yy-searchov-default');
    var sLive     = document.getElementById('yy-searchov-live');
    var sLiveHits = document.getElementById('yy-searchov-live-hits');
    var sLiveLbl  = document.getElementById('yy-searchov-live-label');
    var sEmpty    = document.getElementById('yy-searchov-empty');
    var sLoading  = document.getElementById('yy-searchov-loading');
    var sAll      = document.getElementById('yy-searchov-all');
    var moneyFormat = searchov.getAttribute('data-money-format') || '{{amount}} kr.';
    var searchBase  = (sAll && sAll.getAttribute('href')) || '/search';

    /* --- money formatting (mirrors Shopify's money filter) --- */
    function withDelimiters(cents, precision, thousands, decimal) {
      var n = (cents / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    function fmtMoney(amountStr) {
      var cents = Math.round(parseFloat(amountStr) * 100);
      if (isNaN(cents)) return '';
      var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      var ph = m ? m[1] : 'amount';
      var val;
      switch (ph) {
        case 'amount_no_decimals': val = withDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_comma_separator': val = withDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': val = withDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': val = withDelimiters(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': val = withDelimiters(cents, 0, ' ', ','); break;
        case 'amount_with_period_and_space_separator': val = withDelimiters(cents, 2, ' ', '.'); break;
        default: val = withDelimiters(cents, 2, ',', '.'); /* {{amount}} => 1,234.00 */
      }
      return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, val);
    }

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    function sizedImg(url) {
      if (!url) return '';
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=140';
    }
    function hitHTML(p) {
      var img = sizedImg(p.image || (p.featured_image && (p.featured_image.url || p.featured_image)) || '');
      var priceStr = fmtMoney(p.price != null ? p.price : p.price_min);
      var cmpRaw = p.compare_at_price_min || p.compare_at_price_max || '0';
      var cmp = '';
      /* Tyskland (PAngV): ingen overstreget førpris i søgeforslagene */
      var erDE = (document.documentElement.lang || '').slice(0, 2).toLowerCase() === 'de';
      if (!erDE && parseFloat(cmpRaw) > parseFloat(p.price != null ? p.price : p.price_min)) {
        cmp = ' <s>' + fmtMoney(cmpRaw) + '</s>';
      }
      return '<a class="yy-searchov__hit" href="' + esc(p.url) + '">'
        + '<span class="yy-searchov__hit-img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="70" height="70">' : '') + '</span>'
        + '<span class="yy-searchov__hit-body">'
        + '<span class="yy-searchov__hit-title">' + esc(p.title) + '</span>'
        + '<span class="yy-searchov__hit-price">' + priceStr + cmp + '</span>'
        + '</span></a>';
    }

    function show(el, on) { if (el) el.hidden = !on; }
    function showDefault() {
      show(sDefault, true); show(sLive, false); show(sEmpty, false); show(sLoading, false); show(sAll, false);
    }
    function showLoading() {
      show(sDefault, false); show(sEmpty, false);
      if (!sLive || sLive.hidden) show(sLoading, true);
    }
    function renderResults(q, products) {
      show(sLoading, false); show(sDefault, false);
      if (products.length) {
        sLiveHits.innerHTML = products.map(hitHTML).join('');
        show(sLive, true); show(sEmpty, false);
      } else {
        show(sLive, false); show(sEmpty, true);
      }
      if (sAll) {
        sAll.href = searchBase + (searchBase.indexOf('?') > -1 ? '&' : '?') + 'q=' + encodeURIComponent(q);
        show(sAll, true);
      }
    }

    var debTimer, ctrl;
    function doSearch(raw) {
      var q = (raw || '').trim();
      if (q.length < 2) { showDefault(); return; }
      if (ctrl) ctrl.abort();
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      showLoading();
      var url = '/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product&resources[limit]=6';
      fetch(url, { headers: { 'Accept': 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var products = (j.resources && j.resources.results && j.resources.results.products) || [];
          renderResults(q, products);
        })
        .catch(function (e) { if (!e || e.name !== 'AbortError') { showDefault(); } });
    }

    function toggleClear() { show(sClear, sInput && sInput.value.length > 0); }

    function openSearchov(prefill) {
      searchov.classList.add('is-open');
      searchov.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (isTransparentHeader) header.classList.add('is-solid');
      if (prefill && sInput) { sInput.value = prefill; }
      toggleClear();
      if (prefill) { doSearch(prefill); } else { showDefault(); }
      setTimeout(function () { if (sInput) sInput.focus(); }, 60);
    }
    function closeSearchovFn() {
      searchov.classList.remove('is-open');
      searchov.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      syncSolidHeader();
    }
    /* expose for the shared ESC handler */
    window.yyCloseSearchov = function () {
      if (searchov.classList.contains('is-open')) closeSearchovFn();
    };

    /* Input + clear */
    if (sInput) {
      sInput.addEventListener('input', function () {
        toggleClear();
        clearTimeout(debTimer);
        debTimer = setTimeout(function () { doSearch(sInput.value); }, 180);
      });
    }
    if (sClear) {
      sClear.addEventListener('click', function () {
        if (sInput) { sInput.value = ''; sInput.focus(); }
        toggleClear(); showDefault();
      });
    }

    /* Close controls */
    searchov.querySelectorAll('[data-searchov-close]').forEach(function (el) {
      el.addEventListener('click', closeSearchovFn);
    });

    /* Chips */
    searchov.querySelectorAll('[data-searchov-q]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var q = chip.getAttribute('data-searchov-q') || '';
        if (sInput) { sInput.value = q; sInput.focus(); }
        toggleClear(); doSearch(q);
      });
    });

    /* Triggers: desktop inline field + mobile search icon open the overlay */
    var deskField = header.querySelector('.yy-search');
    if (deskField) {
      deskField.addEventListener('click', function (e) { e.preventDefault(); openSearchov(); });
      var deskInput = deskField.querySelector('.yy-search__input');
      if (deskInput) {
        deskInput.addEventListener('focus', function () { deskInput.blur(); openSearchov(); });
      }
    }
    if (searchToggle) {
      var freshToggle = searchToggle.cloneNode(true); /* strip old mobile-search-bar listener */
      searchToggle.parentNode.replaceChild(freshToggle, searchToggle);
      freshToggle.addEventListener('click', function (e) { e.preventDefault(); openSearchov(); });
    }
  }

  /* ============================================================
     ESC — close everything
  ============================================================ */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeAllDesktopMegas(null);
    closeDrawer();
    closeMobileSearch();
    if (window.yyCloseSearchov) window.yyCloseSearchov();
    syncSolidHeader();
  });

})();
